export const UNIT_EXCEL_FIELD_TYPES = {
  HM2_DESCRIPTIVE: "HM2_DESCRIPTIVE",
  HM2: "HM2",
  ALL: "ALL",
};

export const UnitExcelFieldTypeValues: string[] = Object.values(
  UNIT_EXCEL_FIELD_TYPES,
);
export type UnitExcelFieldType = (typeof UnitExcelFieldTypeValues)[number];
